import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/constantes";
import { RootState } from "@store/store";
import { ExpedienteAutorizadoMercader } from "./ExpedienteAutorizadoMercader";

/**
 * Despacha a la pantalla de expediente autorizado correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de Mercader.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.MERCADER_PM]: ExpedienteAutorizadoMercader,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE]: ExpedienteAutorizadoMercader,
};

export const ExpedienteAutorizado = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || ExpedienteAutorizadoMercader;
  return <Screen />;
};
